import { render, staticRenderFns } from "./template.vue?vue&type=template&id=43fe8531&scoped=true&"
import script from "@/Components/Global/PopupUserForm/component.ts?vue&type=script&lang=ts&"
export * from "@/Components/Global/PopupUserForm/component.ts?vue&type=script&lang=ts&"
import style0 from "@/Components/Global/PopupUserForm/style.scss?vue&type=style&index=0&id=43fe8531&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fe8531",
  null
  
)

export default component.exports